import {RouteEntry} from "../../shared/routes";
import {TrackMyClaim} from "./TrackMyClaim";

export const trackRoutes: Array<RouteEntry> = [
    { path: '/track', component: TrackMyClaim },
];
